/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Order_NoInputs */

const en_settings_payments_order_no = /** @type {(inputs: Settings_Payments_Order_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const zh_settings_payments_order_no = /** @type {(inputs: Settings_Payments_Order_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单号`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {Settings_Payments_Order_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_order_no = /** @type {((inputs?: Settings_Payments_Order_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Order_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_order_no(inputs)
	return zh_settings_payments_order_no(inputs)
});
export { settings_payments_order_no as "settings.payments.order_no" }